var render, staticRenderFns
import script from "./DashboardCheckMixin.vue?vue&type=script&lang=ts&"
export * from "./DashboardCheckMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports